module.exports = __webpack_public_path__ + "static/leroy_merlin-84a6aebc8aacea9cc63666f076b1dc99.svg";